import {useState} from 'react';
import {a11yProps} from "../../helpers/a11y"
import { Typography, AppBar, Tabs, Tab } from "@material-ui/core"
import InvoiageLogo from '../InvoiageLogo';

export default function ValidationAppBar() {

  const boxShadow = "0px 3px 4px -1px rgba(0,0,0,0.2)"

  return (
    <AppBar position="static" color="default" style={{boxShadow}}>
      <Typography variant="h2">Invoiage <InvoiageLogo /> Authorizations</Typography>
    </AppBar>
  )
}